module.exports = __webpack_public_path__ + "img/appAsset-agents-avatar-7.7f21f50c.jpg";